import { environment } from './environment';

export function getBaseUrl() {
  return environment.baseUrl || window.location.origin;
}
